export default [
  // 调查问卷
  {
    path: '/survey/',
    component: () => import('@/views/survey/index.vue'),
    children: [
      {
        path: '',
        name: 'surveyList',
        component: () => {
          return import(
            /* webpackChunkName: "survey" */ '@/views/survey/questions.vue'
          )
        },
        meta: {
          title: '问卷详情'
        }
      },
      {
        path: 'result',
        name: 'surveyResult',
        component: () => {
          return import(
            /* webpackChunkName: "survey" */ '@/views/survey/result.vue'
          )
        },
        meta: {
          title: '问卷详情'
        }
      }
    ]
  }
]
